import { render, staticRenderFns } from "./CrmLeads.vue?vue&type=template&id=49d67f94&scoped=true"
import script from "./CrmLeads.vue?vue&type=script&lang=js"
export * from "./CrmLeads.vue?vue&type=script&lang=js"
import style0 from "./CrmLeads.vue?vue&type=style&index=0&id=49d67f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d67f94",
  null
  
)

export default component.exports